import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'proffeo-projects',
  template: '<router-outlet></router-outlet>',
  imports: [RouterModule]
})
export class ProjectsComponent {}
